// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import './app-base.pcss';
import './app-components.pcss';
import './app-utilities.pcss';
import $ from 'jquery';
import Cookies from 'js-cookie';
import 'lazysizes';
import { gsap } from "gsap";
import { ExpoScaleEase, RoughEase, SlowMo } from "gsap/EasePack";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as YTPlayer from 'yt-player';


window.$ = window.jQuery = $;
var duration = duration || 1; // Default animation speed

$(document).ready(function() {	
	
	
	/* REGISTER GSAP PLUGINS */
	
	gsap.registerPlugin(CSSRulePlugin, ScrollToPlugin, ScrollTrigger, ExpoScaleEase, RoughEase, SlowMo);
	
	
	/* REVEAL ANIMATIONS */
	
	// collect parent triggered reveals
	var fadeIns = gsap.utils.toArray('.anim-elem.fade-in, .anim-parent.fade-in > .inner > .anim-child, .anim-parent.fade-in > .inner > p, section.anim-parent.fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.fade-in > .inner > .container > .inner > p, .anim-parent.fade-in > .inner > .anim-pass .anim-child, section.anim-parent.fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.fade-in > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.fade-in > .inner > .container > .inner .content-sizer > p');
		
	var slideUps = gsap.utils.toArray('.anim-elem.slide-up-fade-in, .anim-parent.slide-up-fade-in > .inner > .anim-child, .anim-parent.slide-up-fade-in > .inner > p, section.anim-parent.slide-up-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.slide-up-fade-in > .inner > .container > .inner > p, .anim-parent.slide-up-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.slide-up-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-up-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.slide-up-fade-in > .inner > .container > .inner > .anim-pass > .inner > .p, section.anim-parent.slide-up-fade-in > .inner > .container > .inner .content-sizer > p');
	
	var slideDowns = gsap.utils.toArray('.anim-elem.slide-down-fade-in, .anim-parent.slide-down-fade-in > .inner > .anim-child, .anim-parent.slide-down-fade-in > .inner > p, section.anim-parent.slide-down-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.slide-down-fade-in > .inner > .container > .inner > p, .anim-parent.slide-down-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.slide-down-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-down-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.slide-down-fade-in > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-down-fade-in > .inner > .container > .inner .content-sizer > p');
	
	var slideLefts = gsap.utils.toArray('.anim-elem.slide-left-fade-in, .anim-parent.slide-left-fade-in > .inner > .anim-child, .anim-parent.slide-left-fade-in > .inner > p, section.anim-parent.slide-left-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.slide-left-fade-in > .inner > .container > .inner > p, .anim-parent.slide-left-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.slide-left-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-left-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.slide-left-fade-in > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-left-fade-in > .inner > .container > .inner .content-sizer > p');
	
	var slideRights = gsap.utils.toArray('.anim-elem.slide-right-fade-in, .anim-parent.slide-right-fade-in > .inner > .anim-child, .anim-parent.slide-right-fade-in > .inner > p, section.anim-parent.slide-right-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.slide-right-fade-in > .inner > .container > .inner > p, .anim-parent.slide-right-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.slide-right-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-right-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.slide-right-fade-in > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-right-fade-in > .inner > .container > .inner .content-sizer > p');
	
	var scaleDowns = gsap.utils.toArray('.anim-elem.scale-down-fade-in, .anim-parent.scale-down-fade-in > .inner > .anim-child, .anim-parent.scale-down-fade-in > .inner > p, section.anim-parent.scale-down-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.scale-down-fade-in > .inner > .container > .inner > p, .anim-parent.scale-down-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.scale-down-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.scale-down-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.scale-down-fade-in > .inner > .container > .inner > .anim-pass > .inner > psection.anim-parent.scale-down-fade-in > .inner > .container > .inner .content-sizer > p');
	
	var scaleUps = gsap.utils.toArray('.anim-elem.scale-up-fade-in, .anim-parent.scale-up-fade-in > .inner > .anim-child, .anim-parent.scale-up-fade-in > .inner > p, section.anim-parent.scale-up-fade-in > .inner > .container > .inner > .anim-child, section.anim-parent.scale-up-fade-in > .inner > .container > .inner > p, .anim-parent.scale-up-fade-in > .inner > .anim-pass .anim-child, section.anim-parent.scale-up-fade-in > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.scale-up-fade-in > .inner > .anim-pass > .inner > p, section.anim-parent.scale-up-fade-in > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.scale-up-fade-in > .inner > .container > .inner .content-sizer > p');	
	
	
	// collect parent triggered reveals with staggering
	
	var fadeInsSubsStagger = gsap.utils.toArray('.anim-parent.fade-in-stagger > .inner > .anim-child, .anim-parent.fade-in-stagger > .inner > p, section.anim-parent.fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.fade-in-stagger > .inner > .container > .inner > p, .anim-parent.fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.fade-in-stagger > .inner > .container > .inner .content-sizer > p');
		
	var slideUpsSubsStagger = gsap.utils.toArray('.anim-parent.slide-up-fade-in-stagger > .inner > .anim-child, .anim-parent.slide-up-fade-in-stagger > .inner > p, section.anim-parent.slide-up-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.slide-up-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.slide-up-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.slide-up-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-up-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.slide-up-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-up-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	var slideDownsSubsStagger = gsap.utils.toArray('.anim-parent.slide-down-fade-in-stagger > .inner > .anim-child, .anim-parent.slide-down-fade-in-stagger > .inner > p, section.anim-parent.slide-down-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.slide-down-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.slide-down-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.slide-down-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-down-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.slide-down-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-down-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	var slideLeftsSubsStagger = gsap.utils.toArray('.anim-parent.slide-left-fade-in-stagger > .inner > .anim-child, .anim-parent.slide-left-fade-in-stagger > .inner > p, section.anim-parent.slide-left-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.slide-left-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.slide-left-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.slide-left-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-left-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.slide-left-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-left-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	var slideRightsSubsStagger = gsap.utils.toArray('.anim-parent.slide-right-fade-in-stagger > .inner > .anim-child, .anim-parent.slide-right-fade-in-stagger > .inner > p, section.anim-parent.slide-right-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.slide-right-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.slide-right-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.slide-right-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.slide-right-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.slide-right-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.slide-right-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	var scaleDownsSubsStagger = gsap.utils.toArray('.anim-parent.scale-down-fade-in-stagger > .inner > .anim-child, .anim-parent.scale-down-fade-in-stagger > .inner > p, section.anim-parent.scale-down-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.scale-down-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.scale-down-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.scale-down-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.scale-down-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.scale-down-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.scale-down-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	var scaleUpsSubsStagger = gsap.utils.toArray('.anim-parent.scale-up-fade-in-stagger > .inner > .anim-child, .anim-parent.scale-up-fade-in-stagger > .inner > p, section.anim-parent.scale-up-fade-in-stagger > .inner > .container > .inner > .anim-child, section.anim-parent.scale-up-fade-in-stagger > .inner > .container > .inner > p, .anim-parent.scale-up-fade-in-stagger > .inner > .anim-pass .anim-child, section.anim-parent.scale-up-fade-in-stagger > .inner > .container > .inner > .anim-pass .anim-child, .anim-parent.scale-up-fade-in-stagger > .inner > .anim-pass > .inner > p, section.anim-parent.scale-up-fade-in-stagger > .inner > .container > .inner > .anim-pass > .inner > p, section.anim-parent.scale-up-fade-in-stagger > .inner > .container > .inner .content-sizer > p');
	
	
	// set initial animation states for reveal elements
	
	fadeIns.forEach(aniItem => {
		gsap.set(aniItem,{	
			opacity: 0
		});
	});
	
	fadeInsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			opacity: 0
		});
	});
	
	
	slideUps.forEach(aniItem => {
		gsap.set(aniItem,{	
			y: 50,
			opacity: 0
		});
	});
	
	slideUpsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			y: 50,
			opacity: 0
		});
	});
	
	slideDowns.forEach(aniItem => {
		gsap.set(aniItem,{	
			y: 50,
			opacity: 0
		});
	});
	
	slideDownsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			y: -50,
			opacity: 0
		});
	});
	
	slideLefts.forEach(aniItem => {
		gsap.set(aniItem,{	
			x: 50,
			opacity: 0
		});
	});
	
	slideLeftsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			x: 50,
			opacity: 0
		});
	});
	
	slideRights.forEach(aniItem => {
		gsap.set(aniItem,{	
			x: -50,
			opacity: 0
		});
	});
	
	slideRightsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			x: -50,
			opacity: 0
		});
	});
	
	scaleDowns.forEach(aniItem => {
		gsap.set(aniItem,{	
			scale: 1.2,
			opacity: 0
		});
	});
	
	scaleDownsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			scale: 1.2,
			opacity: 0
		});
	});
	
	scaleUps.forEach(aniItem => {
		gsap.set(aniItem,{	
			scale: 0.8,
			opacity: 0
		});
	});
	
	scaleUpsSubsStagger.forEach(aniItem => {
		gsap.set(aniItem,{	
			scale: 0.8,
			opacity: 0
		});
	});
	
	//Animation Function
	
	
	function addReveals() {				
		
		// Fade Ins
		
		fadeIns.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,			
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(fadeInsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 			
				opacity: 0,			
			},{
				duration: duration * 1.5,		
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});
		
		
		// Slide Ups
		
		slideUps.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				y: 0,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(slideUpsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				y: 50,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				y: 0,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});	
		
		
		// Slide Downs
		
		slideDowns.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				y: 0,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(slideDownsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				y: -50,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				y: 0,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});
		
		
		// Slide Lefts
		
		slideLefts.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				x: 0,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(slideLeftsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				x: 50,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				x: 0,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});
		
		
		// Slide Rights
		
		slideRights.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				x: 0,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(slideRightsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				x: -50,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				x: 0,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});
		
		// Scale Downs
		
		scaleDowns.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				scale: 1,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(scaleDownsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				scale: 1.2,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				scale: 1,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});	
		
		// Scale Ups
		
		scaleUps.forEach(aniItem => {
			
			gsap.to(aniItem, { 			
				duration: duration * 1.5,
				scale: 1,
				force3D: true,
				opacity: 1,			
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete: postRevealFunction,
				onCompleteParams: [aniItem],			
				scrollTrigger: {
					trigger: aniItem,
					start: "top 95%",
				}			
			})
		});	
		
		
		ScrollTrigger.batch(scaleUpsSubsStagger, {
			onEnter: batch => gsap.fromTo(batch, 
			{ 
				scale: 0.8,
				opacity: 0,
				force3D: true,
			},{
				duration: duration * 1.5,
				scale: 1,
				force3D: true,
				opacity: 1,
				// Note: Easing Pack required for easing
				ease: "expo.out",
				onComplete() {
					for (let i = 0; i < this._targets.length - 1 ; i++) {
						postRevealFunction(this._targets[i]);
					}
				},
				stagger: 0.15			
			}),
			start: "top 95%",
			once: true
		});		
	}
	
	/* POST REVEAL FUNCTIONS */
		
	function postRevealFunction(el) {		
		console.log();
	}
	
	
	
	
	/* MODAL BEHAVIORS */
	
	var modalOpenTL = gsap.timeline({repeat: 0, paused: true, onComplete: modalSliderInit});
	modalOpenTL.fromTo("#modal-wrapper, #modal-overlay", {opacity: 0}, {duration: 0.5, ease: "power1.out", opacity: 1});
	modalOpenTL.fromTo("#modal", {opacity: 0, y: 100}, {duration: 0.5, ease: "power1.out", opacity: 1, y: 0});
	
	var modalCloseTL = gsap.timeline({repeat: 0, paused: true, onComplete: clearModal});
	modalCloseTL.fromTo("#modal-wrapper", {opacity: 1}, {duration: 0.5, ease: "power1.out", opacity: 0});
	
	var focusable_selectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
	
	function clearModal() {
		$('#modal, #modal-wrapper').addClass('closed');				
		$('#wrapper').css('top', '0px');	
		$('body, html').removeClass('modal-active');		
		$('#modal-content').html('');
		
		//accessibility features - restore states prior to modal open				
		$('#page-wrapper').find(focusable_selectors).removeAttr('tabindex');
		$('#page-wrapper').removeAttr('aria-hidden');	
		$('#modal').attr('aria-hidden', 'true');
		$('#modal').css('height', '0px');
		//set focus to element that triggered modal if it was a button
		var focusTarget = '#' + $('#modal').data('trigger-el');		
		$(focusTarget).focus();
		$('#modal').removeAttr('data-trigger-el');				
	}
	
	function modalSizer() {
		var contentHeight = ($('#modal-content-inner-wrapper').innerHeight()) + ($('#modal-title').innerHeight());						
		var modalHeight = (45 + contentHeight) + 'px';
		$('#modal').css('height', modalHeight);
	}
	
	function showModal(whichModal, triggerEl) {			
		//show modal
		console.log('showmodal');
		var scrollPoint = window.scrollY;
		var scrollValue = '-' + scrollPoint + 'px';
		$('body, html').addClass('modal-active');		
		$('#wrapper').css('top', scrollValue);	
		$('#modal, #modal-wrapper').removeClass('closed');
		//set data attribute with triggering element if there is one to set focus to on close of modal
		if (triggerEl) {
			$('#modal').attr('data-trigger-el', triggerEl);
		}		
		//load content			
		$('#modal-content').load(whichModal, function() {
			modalSizer()
		});			
		modalOpenTL.play(0);
		
		//accessibility features - focus on modal header, trap focus inside modal until closed		
		$('#modal-title').focus();		
		$('#page-wrapper').find(focusable_selectors).attr('tabindex', '-1');
		$('#page-wrapper').attr('aria-hidden', 'true');	
		$('#modal').attr('aria-hidden', 'false');	
	}	
	
	function closeModal() {		
		modalCloseTL.play(0);	
	}
	
	function swapModal(whichModal) {
		$('#modal-content').load(whichModal, function() {
			modalSizer()
		});
	}
	
	$('#modal-overlay, #btn-modal-close').click(function() {
		closeModal();
	});
	
		
	$('.btn-modal').click(function(e) {
		e.preventDefault();
		var btnId = $(this).attr('id');
		var btnTarget = $(this).data('modal-target');
		showModal(btnTarget, btnId);
	});
	
	$(document).on('click', '#modal-content-inner-wrapper .btn-modal', function(e) {
		e.preventDefault();
		var btnId = $(this).attr('id');
		var btnTarget = $(this).data('modal-target');
		swapModal(btnTarget, btnId);
	});
	
		
	/* LOADER FUNCTIONALITY */
		
	function turnoffloader() {
		console.log('turnoffloader');
		//headerPadFix();		
		addReveals();
		$('body').addClass('pageloaded');
		if ($('body').attr('id') == 'page-blog-search') {			
			var ajaxblogsearchurl = '/resources/blogResults/?';			
			var myurl = new URL(window.location.href);
			var urlParams = new URLSearchParams(myurl.search);			
			var searchparam, catparam, yearparam, searchval, catval, yearval; 
			searchparam = urlParams.get('query');
			//console.log(searchparam);
			if (searchparam == null) {
				searchval = '';
			} else {
				searchval = searchparam;
			}		
			catparam = urlParams.get('cat');
			if (catparam == null) {
				catval = '';
			} else {
				catval = catparam;
			}
			yearparam = urlParams.get('year');
			if (yearparam == null) {
				yearval = '';
			} else {
				yearval = yearparam;
			}
			var queryparams = 'query=' + searchval + '&cat=' + catval + '&year=' +yearval;			
			var ajaxurl = ajaxblogsearchurl + queryparams;
			//console.log(ajaxurl);
			blogSearchRefresh(ajaxurl);
		}				
		if ($('body').hasClass('load-modal')) {
			var modalUrl = $('body').data('load-modal');
			showModal(modalUrl);
		}
	}
	
	
	/* DO THE THINGS IF NOT IN LIVE PREVIEW IN CONTROL PANEL */
	
	if (!($('body').hasClass('ispreview'))) {
		
		/* GET LOGIN STATUS AND POPULATE LOGIN BAR IF LOGGED IN */
		
		$("#login-status-bar-wrapper").load("/resources/loginbar");		
				
		var loadAnim = gsap.to("#loader", {duration: 0.5, ease: "power1.out", opacity: 0, paused: true, repeat: 0,  onComplete:turnoffloader});
		loadAnim.play();			
	}
	
	/* GET WINDOW SIZE AND ADD CLASS TO BODY TAG TO ASSIST IN MENU CONTROL ON MOBILE DEVICES */
			
	var menuWidth = $('html').width();
	
	function sizeMarker() {
		var screenWidth = $('html').width();		
		$('body').removeClass('size-mobile size-tablet size-laptop size-desktop');
		if (screenWidth < 768) {
			$('body').addClass('size-mobile');
			menuWidth = $('html').width();								
		} else if ((screenWidth >= 768) && (screenWidth < 1024 )) {
			$('body').addClass('size-tablet');
			menuWidth = $('html').width();
		} else if ((screenWidth >= 1024) && (screenWidth < 1280 )) {
			$('body').addClass('size-laptop');
		} else {
			$('body').addClass('size-desktop');
		}
	}
	
	/*
	function headerPadFix() {
		var padSize = $('#site-header').outerHeight() + 'px';
		//console.log(padSize);
		if ($('body').attr('id') != 'page-home') {
			$('#page-wrapper').css('paddingTop', padSize);	
		}		
	}
	*/
	
	sizeMarker();
	
	
	
	$(window).resize(function() {
		sizeMarker();		
		$('#mm_wrapper').attr('style','');
		//headerPadFix();	
		modalSizer();
		$('body').removeClass('fixed');
		
		/* open all service icon sections */
		var screenWidth = $('html').width();
		if (screenWidth >= 768) {
			var serviceIconBlockButtons = $('.btn-service-icon-section-button');
			serviceIconBlockButtons.each(function() {			
				var myAcc = '#' + ($(this).parent('.service-icon-section-button-header').parent('.inner').parent('.sectionServiceIconAcc').attr('id')); /* id of the accordion the clicked button is in */
				var myId = '#' + ($(this).attr('id')); /* the id of the button that was clicked */
				var myTarget = $(this).data('target'); /* the id of the panel that is triggered by the button */
				var mySet = $(this).data('parent');
				serviceIconFunction(1, myAcc, myId, myTarget);
				$(myAcc + ' .accordion-panel').removeAttr('style');
			});	
		}				
	});
	
	
	/* NOTIFICATION ALERT LOADING */
		
	$('#header_topbar').load('/resources/notificationbaralerts', function() {
		//headerPadFix();
	});
	$('#header_topbar_secondary').load('/resources/notificationbartextalerts', function() {
		//headerPadFix();
	});
	
		
	
	
	/* HOME PAGE SCROLL FUNCTION */
	
	
	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;	
		
	$(window).scroll(function(){		
		didScroll = true;
	});
	
	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);
	
	function hasScrolled() {		
		if ($('body').attr('id') == 'page-home') {
			var homeScrollHeight = $('.pageHeaderHome').outerHeight();
			var st = $(window).scrollTop();	
			//console.log(homeScrollHeight);	
			// Make sure they scroll more than delta
			if(Math.abs(lastScrollTop - st) <= delta)
				return;
			
			// If they scrolled down and are past the page header, add class .nav-show.
			// This is necessary so you never see what is "behind" the navbar.
			if ((st > lastScrollTop && st > homeScrollHeight) && ($('#wrapper').hasClass('mmopen') == false )){
				// Scroll Down			
				$('body#page-home').removeClass('nav-hide').addClass('nav-show');
			} else {
				// Scroll Up
				if((st < lastScrollTop && st < homeScrollHeight) && ($('#wrapper').hasClass('mmopen') == false )) {				
					$('body#page-home').removeClass('nav-show').addClass('nav-hide');
				}
			}
			
			lastScrollTop = st;
		}		
	}
	
	/* MOBILE MENU FUNCTIONALITY */	
	
	var menuAnimating = false;
		
	$('#btn-mm-open, #btn-mm-open-home-header').click(function() {			
		
		if (!menuAnimating && (($('body').hasClass('size-mobile'))||($('body').hasClass('size-tablet')))) {
			menuAnimating = true;								
			var mobileMenuPanelOpen = gsap.fromTo("#main_menu", {x: menuWidth}, {duration: 0.5, ease: "power1.out", x: 0, paused: true});
			mobileMenuPanelOpen.play();			
			$('#wrapper').addClass('mmopen');
			$('body').addClass('fixed');
			menuAnimating = false;					
		}
			
	});	
	
	
	$('#btn-mm-close').click(function() {			
		
		//console.log('firing');
		if (!menuAnimating && ($('#wrapper').hasClass('mmopen')) && (($('body').hasClass('size-mobile')) || ($('body').hasClass('size-tablet')))) {
			menuAnimating = true;			
			menuWidth = $('html').width();			
			var mobileMenuPanelClose = gsap.to("#main_menu", {duration: 0.5, ease: "power1.out", x: menuWidth, paused: true});
			mobileMenuPanelClose.play();
			$('#wrapper').removeClass('mmopen');
			$('body').removeClass('fixed');
			menuAnimating = false;				
		}
			
	});	
				
	
	/* ACCORDION BEHAVIOR */
	
	function accordionFunction(toggleFunction, acc, btn, pnl) {		
		var accordion, button, panel;
		/* grab dom elements based on ids */
		accordion = $(acc);
		button = $(btn); /* button id doesn't have hash in it as passed */
		panel = $(pnl);
		
		/* check toggleFunction to see if opening or closing */
		
		if (toggleFunction == 1) {			
			accordion.addClass('expanded');
			var accInner = accordion.find('.accordion-inner');			
			button.addClass('expanded');
			button.attr('aria-expanded', 'true');
			panel.addClass('expanded');
			panel.height(accInner[0].scrollHeight);		
		} else {			
			accordion.removeClass('expanded');
			button.removeClass('expanded');
			button.attr('aria-expanded', 'false');
			panel.removeClass('expanded');
			panel.height(0);
		}
	}
	
	
	
	$(document).on('click', '.accordion .btn-accordion', function() {			
		var mySet, myAcc, myTarget, myId;
		myAcc = '#' + ($(this).parent('.accordion-button-header').parent('.inner').parent('.accordion').attr('id')); /* id of the accordion the clicked button is in */
		myId = '#' + ($(this).attr('id')); /* the id of the button that was clicked */
		myTarget = $(this).data('target'); /* the id of the panel that is triggered by the button */
		mySet = $(this).data('parent'); /* the id of the set containing the accordion if there is one */
		
		if ($(this).hasClass('expanded')) {
			/* call accordionFunction to close the clicked occordion since it is already open */
			accordionFunction(0, myAcc, myId, myTarget);
		} else {		
			/* check to see if accordion is part of a set and allows multiple opens or not */		
			if (mySet != undefined && $(mySet).hasClass('accordionSetSingleOpen')) { 				
				var closeAcc, closeBtn, closePnl;
				closeAcc = '#' + ($(mySet + ' .accordion.expanded').attr('id'));
				closeBtn = '#' + ($(mySet + ' .accordion.expanded .btn-accordion').attr('id'));
				closePnl = '#' + ($(mySet + ' .accordion.expanded .accordion-panel').attr('id'));				
				accordionFunction(0, closeAcc, closeBtn, closePnl); /* close currently open panel because set doesn't allow multiple opens */
				accordionFunction(1, myAcc, myId, myTarget); /* open the accordion where the button was clicked */
			} else {
				//console.log('accfunc');
				accordionFunction(1, myAcc, myId, myTarget); /* open the accordion where the button was clicked */
			}		
		}
	});	
	
	
	/*open accordion if hash matches id */
	var hashname = $(location).prop('hash').substr(1);
	var hashnameString = String(hashname);
	if (hashnameString.length > 0 && hashnameString.indexOf('gsc.tab=') == -1) {
		var targetAcc = $('#' + hashnameString);		
		if (targetAcc.length) {
			var accBtnId = '#' + hashname + '-button';		
			$(accBtnId).click();
			var targetScrollPos = $(targetAcc).offset().top - ($('#site-header').outerHeight() + 60);
			//console.log(targetScrollPos);
			$('html, body').animate({
				scrollTop: targetScrollPos
			},500);
		}
					
	}
	
	
	/* resize slide accordion panel when window is resized) */
	$(window).resize(function() {
		var openAccs = $('.accordion.expanded');
		openAccs.each(function() {
			var accInner = $(this).find('.accordion-inner');
			var btn = $(this).find('.btn-accordion');		
			var panel = $(btn.data('target'));
			panel.height(accInner[0].scrollHeight);
		});	
	});
	
	function serviceIconFunction(toggleFunction, acc, btn, pnl) {		
		var accordion, button, panel;
		/* grab dom elements based on ids */
		accordion = $(acc);
		button = $(btn); /* button id doesn't have hash in it as passed */
		panel = $(pnl);
		
		/* check toggleFunction to see if opening or closing */
		
		if (toggleFunction == 1 ) {			
			accordion.addClass('expanded');
			var accInner = accordion.find('.service-icon-accordion-inner');			
			button.addClass('expanded');
			button.attr('aria-expanded', 'true');
			panel.addClass('expanded');
			panel.height(accInner[0].scrollHeight);		
		} else {			
			accordion.removeClass('expanded');
			button.removeClass('expanded');
			button.attr('aria-expanded', 'false');
			panel.removeClass('expanded');
			panel.height(0);
		}
	}
	
	
	$(document).on('click', '.btn-service-icon-section-button', function() {			
		var mySet, myAcc, myTarget, myId;
		myAcc = '#' + ($(this).parent('.service-icon-section-button-header').parent('.inner').parent('.sectionServiceIconAcc').attr('id')); /* id of the accordion the clicked button is in */
		myId = '#' + ($(this).attr('id')); /* the id of the button that was clicked */
		myTarget = $(this).data('target'); /* the id of the panel that is triggered by the button */
		mySet = $(this).data('parent'); /* the id of the set containing the accordion if there is one */		
		if ($(this).hasClass('expanded')) {			
			/* call accordionFunction to close the clicked occordion since it is already open */			
			serviceIconFunction(0, myAcc, myId, myTarget);
		} else {			
			serviceIconFunction(1, myAcc, myId, myTarget); 
			/* open the accordion where the button was clicked */					
		}
	});
	
	
	
	
	
	
	/* TABSET BEHAVIORS */
	$(document).on('click', '.btn-tab', function() {		
		if (!($(this).hasClass('active-tab'))) {
			var prevPanel, myTabSet, myPanel;
			myTabSet = $(this).data('parent');
			prevPanel = $(myTabSet + ' .tabPanel.active-tab');
			myPanel = $(this).data('target');		
			//$(myTabSet + ' .tabPanel.prev-tab').removeClass('prev-tab');
			$(myTabSet + ' .btn-tab.active-tab').removeClass('active-tab');
			prevPanel.removeClass('active-tab').addClass('prev-tab');
			prevPanel.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',   
			function() {	
				prevPanel.removeClass('prev-tab');	
			});
			$(this).addClass('active-tab');
			$(myPanel).addClass('active-tab');
		}
	});
	
	
	/* CONTENT VIDEO HANDLING */
	/*
	$(document).on('click', '.video-play-btn', function() {
		var $parent = $(this).closest('.contentVideo'),
		fadeOutSelector = '#' + $parent.attr('id') + ' .video-play-btn, ' + '#' + $parent.attr('id') + ' .video-image',
		fadeInSelector = '#' + $parent.attr('id') + ' .video-player',
		$contentToFadeOut = $(fadeOutSelector),
		$contentToFadeIn = $(fadeInSelector),
		videoSelector,
		$video,
		youtubePlayer,
		youtubeVideoId,
		dur = 1,
		tm;
	
		if(!$parent.hasClass('block-video_-playing')) {
			tm = new gsap.timeline();
		
			// $poster = $parent.find('.blc-vid__poster').first();
			videoSelector = fadeInSelector + ' > .video';
			$video = $(videoSelector);
		
			youtubeVideoId = $video.data('youtube-id');
		
			tm.fromTo($contentToFadeIn, dur,
				{
					opacity: 0
				},
				{
					opacity: 1,
					ease: "sine"			
				}
			).fromTo($contentToFadeOut, 2,
				{
					opacity: 1
				},
				{
					opacity: 0,
					ease: "sine",
					onComplete: function() {
						$(fadeOutSelector).css("z-index","-1");
					}
				},
				'-=' + dur
			).add(function() {
				youtubePlayer = new YTPlayer('#vid-' + youtubeVideoId, {
					width: '640',
					height: '360',
					related: false
				});
				youtubePlayer.load(youtubeVideoId, true);
			});
			$parent.addClass('block-video_-playing');
		}
	});
	*/
	
	/* SLIDER SETUP AND FUNCTIONALITY */
			
	function sliderInit(sliders) {
		sliders.each(function() {		
			var timingsetting, swiperEl, swiperOptions, paginationEl, prevEl, nextEl;		
			swiperEl = '#' + $(this).find('.swiper').attr('id');
			paginationEl = '#' + $(this).find('.swiper-pagination').attr('id');			
			prevEl = '#' + $(this).find('.swiper-button-prev').attr('id');										
			nextEl = '#' + $(this).find('.swiper-button-next').attr('id');								
			timingsetting = $(this).data('timing');	
						
			swiperOptions = {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				centeredSlides: true,
				noSwipingSelector: 'a',									
			};
			
			if ($(this).data('autoplay') == '1') {
				swiperOptions.autoplay = {
					delay: timingsetting,
					disableOnInteraction: false,
					speed: 600,
				}
			}
			
			if ($(this).data('effect') == 'fade') {
				swiperOptions.effect = 'fade';
				swiperOptions.fadeEffect = {
					crossFade: true
				}
			} 
			
			if ($(this).data('dots')) {			
				swiperOptions.pagination = {
					el: paginationEl,
					clickable: true
				}
			}
			
			if ($(this).data('buttons')) {
				swiperOptions.navigation = {
					nextEl: nextEl,
					prevEl: prevEl
				}
			}
			
			const mySwiper = new Swiper(swiperEl, swiperOptions);
			//mySwiper.init();					
		});
	}
	
	function modalSliderInit() {
		var modalSliders = $('#modal-content-inner-wrapper .sliderSet');
		sliderInit(modalSliders);
	}
	
	sliderInit($('.sliderSet, .repeaterSlider'));
	
	
		
	
	/* FIX FORMS TO WORK WITH BLITZ CACHE BY DYNAMICALLY RESETTING CSRF TOKENS AND HASH VALUES */
	
	$("form:not('.embedform, .searchform, .calcform')").each(function() {
		var form = $(this);
		var formhandle = form.data('handle');
		
		$.ajax({
			// Specify the form handle in the GET parameters
			// ! Make sure to change the `myFormHandle` to your specific form handle.
			url: '/resources/formfixer?form=' + formhandle,
			type: 'get',
			dataType: 'json',
			success: function (response) {				
				// Update the Form Hash
				form.children('input[name=formHash]').val(response.hash);
				form.children('input[name=freeform_payload]').value = response.payload;
				// Update the JS Honeypot (ONLY when JS Enhancement setting is ON)
				/*
				var honeypot = response.honeypot;
				var honeypotInput = form.children('input[name^="freeform_form_handle"]');
				honeypotInput.attr('id', honeypot.name);
				honeypotInput.attr('name', honeypot.name);
				honeypotInput.val(honeypot.hash);
				*/
				// Locate and update the CSRF input
				var csrf = response.csrf;
				form.children('input[name=' + csrf.name + ']').val(csrf.value);				
			},
		});
	});
	
	
	/* BLOG SEARCH FUNCTION */
	
	function blogSearchRefresh(requrl) {
		$('#blogresults-wrapper').load(requrl, function() {
			$('#blogresults-wrapper').addClass('loaded');
		});		
	} 
	
	
	
	$('#blogsearchsubmit').click(function(e) {
		e.preventDefault();
		var blogsearchurl = '/learn/blog/search/?';
		var ajaxblogsearchurl = '/resources/blogResults/?';
		var searchparam = $('#blogsearchquery').val();
		var catparam = $('#blogcategory').val();
		var yearparam = $('#blogyear').val();
		var queryparams = 'query=' + searchparam + '&cat=' + catparam + '&year=' +yearparam;
		var pageurl = window.location.href;
		var segments = pageurl.split( '/' );
		if ((segments[4] == 'blog') && (segments[5] == 'search')) {
			var ajaxurl = ajaxblogsearchurl + queryparams;
			$('#blogresults-wrapper').removeClass('loaded');
			blogSearchRefresh(ajaxurl);
		} else {
			var fullurl = blogsearchurl + queryparams;
			window.location.replace(fullurl);
		}				
	});
	
	/* RATE TABLES FILTER */
	
	$('#accfilter').on('change', function() {
		var selectedfilter = $(this).val();		
		if (selectedfilter  == '') {
			$('.accGroup').show();
		} else {
			var filterquery = ".accGroup:not(#" + selectedfilter + ")";
			var filterid = '#' + selectedfilter;
			$(filterquery).hide();
			$(filterid).show();
		}
	});
	
	
	/* FIX ERROR DISPLAY ON NEWSLETTER FORM */
	
	document.addEventListener("freeform-render-field-errors", function (event) {
		// Stop the default field error rendering
		if (event.form.id == 'newsletter-form') {
			event.preventDefault();
		
			var form = event.form;		
			var errors = event.errors;	
			
			var errorEl = document.createElement('div');
			errorEl.className = 'ff-errors';
			
			for (var fieldHandle in errors) {
				errorEl.appendChild(document.createTextNode(errors[fieldHandle]));
			}
			
			form.appendChild(errorEl);
		}		
	});
	
	/* External Link Overlay */
	
	var whitelistpatterns = [{"linkurl": '^[/|#].+', "exactmatch": 0}, {"linkurl":'^mailto:', "exactmatch": 0}, {"linkurl": '^tel:', "exactmatch": 0}, {"linkurl": '^javascript', "exactmatch": 0}];
	
	function setWhiteListLinks() {
		//console.log(whitelistpatterns);		
		$('a').each(function(){				
			var hasMatch = false;
			for (var wlLoop = 0; wlLoop < whitelistpatterns.length; wlLoop++) {
				if (whitelistpatterns[wlLoop].exactmatch) {
					//exact match url
					if (!hasMatch) {
						if ($(this).attr('href') == whitelistpatterns[wlLoop].linkurl) {
							$(this).addClass('local');
							hasMatch = true;
						}
					} 
					
				} else {
					//pattern match url					
					var testRegExp = new RegExp(whitelistpatterns[wlLoop].linkurl);				
					if (!hasMatch) {
						if( testRegExp.test($(this).attr('href'))){ 						
							$(this).addClass('local');
							hasMatch = true;
						}
					}
					
				}			 				
			}
			if (!hasMatch) {
				var url = $(this).attr('href');
				if(url.length > 1)
				{
					$(this).addClass('external');					
				}
			}
		});
	}
	
	
	function setWhiteList() {			
		$.ajax({
			url: "/resources/speedbumpwhitelist",
			dataType: "json",
			success: function(data) {				
				for (var domainitem in data) {
					var myRegExp = "^(http|https)://";
					var itemText = data[domainitem].linkurl;
					if (itemText.startsWith("https://")) {
						itemText = itemText.slice(8);
					}
					if (itemText.startsWith("http://")) {
						itemText = itemText.slice(7);
					}
					if (itemText.endsWith("/")) {
						itemText = itemText.slice(0,-1);
					}
					myRegExp += itemText;
					if (data[domainitem].exactmatch) {
						whitelistpatterns.push({"linkurl": data[domainitem].linkurl, "exactmatch": data[domainitem].exactmatch});
					} else {				
						whitelistpatterns.push({"linkurl": myRegExp, "exactmatch": data[domainitem].exactmatch});
					}
				}
				setWhiteListLinks();			
			},
			error: function(xhr, status, error) {
			  var err = eval("(" + xhr.responseText + ")");
			  console.log(error);
			}
		});
	}	
	setWhiteList();	
	
	
	var focusReturnItem;
	
	$('body').on('click', 'a.external', function(e){	
		e.preventDefault();
		focusReturnItem = $(this);
		var myurl = $(this).attr('href');		
		$('#ext-proceed').attr('href', myurl); 
		$('#ext-proceed').attr('title', myurl);
		$('body').removeClass('ext-overlay-open');
		$('body').toggleClass('ext-overlay-open'); 
		setTimeout(function(){
		  $('#ext-proceed').focus();
		}, 500);
	});
	
	$('#ext-link-overlay-close, #ext-link-back').click(function(e) {
		e.preventDefault();
		$('body').removeClass('ext-overlay-open');		 
		if (focusReturnItem.parents('#site-header').length == 0 ) {
			focusReturnItem.focus(); 
		} else {
			$('#site-logo').focus();
		}        
	});
	
	$('#ext-link-overlay-close').blur(function(){
		if ($('body').hasClass('ext-overlay-open')) {
			$('#ext-proceed').focus(); 
		} 
	});
	
	$('#ext-proceed').blur(function(){
		if ($('body').hasClass('ext-overlay-open')) {
			$('#ext-link-back').focus(); 
		} 
	});
	
	$('#ext-link-back').blur(function(){
		if ($('body').hasClass('ext-overlay-open')) {
			$('#ext-link-overlay-close').focus(); 
		} 
	});
	
	$( "#external-link-overlay" ).on( "keydown", "a", function(e) {		
		
		if ($('body').hasClass('ext-overlay-open')) {
			if (e.keyCode === 9) {
				e.preventDefault();
				if ($('#ext-proceed').is(':focus')) {
					$('#ext-link-back').focus();
				} else if ($('#ext-link-overlay-close').is(':focus')) {
					$('#ext-proceed').focus();
				} else if ($('#ext-link-back').is(':focus')) {
					$('#ext-link-overlay-close').focus();
				}
			}			 
		} 
	});
	
	$('#ext-proceed').on('click', function() {
		$('body').removeClass('ext-overlay-open');		 
		if (focusReturnItem.parents('#site-header').length == 0 ) {
			focusReturnItem.focus(); 
		} else {
			$('#site-logo').focus();
		}
	});
	
	
	/* CALCULATOR FUNCTIONS */
	
	function calcResults(calcBlock, resultText, panel, accInner) {
		var resultsBlock = calcBlock + '-results';
		var alertsBlock = calcBlock + '-alerts';
		$(alertsBlock).empty();
		$(alertsBlock).hide();
		$(resultsBlock).empty();
		$(resultsBlock).hide();
		$(resultsBlock).html(resultText);
		$(resultsBlock).fadeIn(1500, function() {			
			if (accInner[0] != undefined && panel != undefined) {
				panel.height(accInner[0].scrollHeight);
			}
		});		
	}
	
	function calcAlerts(calcBlock, msgText, panel, accInner) {
		var resultsBlock = calcBlock + '-results';
		var alertsBlock = calcBlock + '-alerts';
		$(alertsBlock).empty();
		$(alertsBlock).hide();
		$(resultsBlock).empty();
		$(resultsBlock).hide();
		$(alertsBlock).html(msgText);
		$(alertsBlock).fadeIn(1500, function() {			
			if (accInner[0] != undefined && panel != undefined) {
				panel.height(accInner[0].scrollHeight);
			}
		});
		$('html, body').animate({
			scrollTop: $(calcBlock).offset().top
		}, 1000);
	}
	
	/* Loan calculator */
		
	$('.loancalcform').on('submit', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var myBlock, myData, myAlertText, myResultText, myFormVals, isValid, myAlerts, myPanel, myAccInner;
		myAccInner = $(this).parents('.accordion-inner');			
		myPanel = $(this).parents('.accordion-panel');
		/* Grab block id for submitted form */
		myBlock = $(this).data('blockid');
		isValid = true;
		/* put form submission data into object */
		myData = $(this).serializeArray();
		myAlerts = [];
		myAlertText = '';
		myFormVals = {};
		for (var i = 0; i < myData.length; i++) {
			myFormVals[myData[i].name] = myData[i].value;
		}
		/* Validate form submission */
		/* check value of loan amount and monthly payment if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.loanamount)) || parseFloat(myFormVals.loanamount) <= 0) && (isNaN(parseFloat(myFormVals.monthlypayment)) || parseFloat(myFormVals.monthlypayment) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter either a loan amount or a monthly payment. Values must be more than 0.');
		}
		
		if ((!isNaN(parseFloat(myFormVals.loanamount)) && parseFloat(myFormVals.loanamount) >= 0) && (!isNaN(parseFloat(myFormVals.monthlypayment)) && parseFloat(myFormVals.monthlypayment) >= 0)) {
			isValid = false;
			myAlerts.push('Please enter either a loan amount or a monthly payment, not both. Values must be more than 0.');
		}
		 
		/* check value of interest rate */
		if (isNaN(parseFloat(myFormVals.interestrate)) || parseFloat(myFormVals.interestrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an annual percentage rate greater than 0.00');
		}
		/* check value of term */
		if (isNaN(parseInt(myFormVals.loanlength)) || parseInt(myFormVals.loanlength) <= 0) {
			isValid = false;
			myAlerts.push('Please enter a loan length breater than 0');
		}
		/* if form validates perform calculations, otherwise put up alerts */
		if (isValid) {
			var term, interest, totalLoan;
			myResultText = '';
			if(myFormVals.unit == 'y') {
				term = myFormVals.loanlength * 12;
			} else {
				term = myFormVals.loanlength;
			}
			if ((!isNaN(parseFloat(myFormVals.loanamount)) && parseFloat(myFormVals.loanamount) >= 0)) {				
				var principle = myFormVals.loanamount;
				interest = myFormVals.interestrate / 1200;
				var monthlyPayment = principle * interest / (1 - (Math.pow(1/(1 + interest), term)));
				totalLoan = Number(monthlyPayment * term).toFixed(2);
				monthlyPayment = Number(monthlyPayment).toFixed(2);
			} else if ((!isNaN(parseFloat(myFormVals.monthlypayment)) && parseFloat(myFormVals.monthlypayment) >= 0)) {				
				interest = myFormVals.interestrate / 1200;
				interest = interest + 1;
				totalLoan = 0;
				var numpds = term;
				var pdRate =  myFormVals.interestrate / 1200;
				var v1 = 1 + pdRate;
				var v2 = Math.pow(v1,(-numpds));
				var v3 = -myFormVals.monthlypayment + ((Math.pow(v1,numpds))* myFormVals.monthlypayment);			
				var maxLoan = Number((v2*v3)/ pdRate).toFixed(2);			
			}
			
			if(monthlyPayment) {
				myResultText = '<div class="text-xl font-bold mt-normal">Your Monthly Payments Will Be Approximately:</div><div class="text-3xl text-blue-footer">$'+monthlyPayment+'</div><div class="mt-base text-xl font-bold">Your Total Loan Repayment After Interest Will Be:</div><div class="text-3xl text-blue-footer">$'+totalLoan+'</div>';
				calcResults('#' + myBlock, myResultText, myPanel, myAccInner);					
			} else if(maxLoan) {
				myResultText = '<div class="text-xl font-bold mt-normal">Your total loan repayment after interest would be:</div>' +
				'<div class="text-3xl text-blue-footer">$'+maxLoan+'</div>';					
				calcResults('#' + myBlock, myResultText, myPanel, myAccInner);
			}
			
		} else {
			myAlertText = '<ul>';
			for (var j = 0; j < myAlerts.length; j++) {
				myAlertText = myAlertText + '<li>' + myAlerts[j] + '</li>';
			}
			myAlertText = myAlertText + '</ul>';			
			calcAlerts('#' + myBlock, myAlertText, myPanel, myAccInner);
		}				
	});
	
	/* Loan Payoff calculator */
			
	$('.loanpayoffcalcform').on('submit', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var myBlock, myData, myAlertText, myResultText, myFormVals, isValid, myAlerts, myPanel, myAccInner;
		myAccInner = $(this).parents('.accordion-inner');			
		myPanel = $(this).parents('.accordion-panel');
		/* Grab block id for submitted form */
		myBlock = $(this).data('blockid');
		isValid = true;
		/* put form submission data into object */
		myData = $(this).serializeArray();
		myAlerts = [];
		myAlertText = '';
		myFormVals = {};
		for (var i = 0; i < myData.length; i++) {
			myFormVals[myData[i].name] = myData[i].value;
		}
		/* Validate form submission */
		/* check value of beginning loan balance if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.beginningloanbalance)) || parseFloat(myFormVals.beginningloanbalance) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a beginning loan balance. Value must be more than 0.00.');
		}
		
		/* check value of minimum payment if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.minpayment)) || parseFloat(myFormVals.minpayment) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a minimum payment amount. Value must be more than 0.00.');
		}
		
		/* check value of maximum payment if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.maxpayment)) || parseFloat(myFormVals.maxpayment) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a maximum payment amount. Value must be more than 0.00.');
		}
		 
		/* check value of interest rate */
		if (isNaN(parseFloat(myFormVals.interestrate)) || parseFloat(myFormVals.interestrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an annual percentage rate greater than 0.00');
		}
		
		
		/* if form validates perform calculations, otherwise put up alerts */
		if (isValid) {
			myResultText = '<div class="text-3xl text-blue-footer">Loan Payoff Estimations</div><div class="mt-base text-xl">';
			var abal = parseFloat(myFormVals.beginningloanbalance);
			var pay1 = parseFloat(myFormVals.minpayment);
			var pay2 = parseFloat(myFormVals.maxpayment);
			var intr = parseFloat(myFormVals.interestrate)/1200;
						
			
			for (var k=0; k<2; k++) {
			  var mv = abal;
			  var mm = 0;
			  var ti = 0;
			  var py, mt;
			  if (k == 0) {
				py = pay1;
				mt = "minimum";
			  } else {
				py = pay2;
				mt = "maximum";
			  }
			  
			  while(mv > 0 && mm < 1200) {
				var mi = mv * intr;
			    ti = ti + mi;
				mv = mv + mi - py;				
			    mm++;
			  }
			  
			  
			  var years = Number(mm/12).toFixed(2);
			  var totInt = Number(ti).toFixed(2);
			  var monthlyInt = Number(ti/mm).toFixed(2);
			
			  myResultText = myResultText + '<p>Using the <span class="font-bold text-blue-footer">'+mt+'</span> payment it will take <span class="font-bold text-blue-footer">'+mm+'</span> months(<span class="font-bold text-blue-footer">'+years+'</span> years) to pay off your loan.<br>Your total interest paid on the loan will be <span class="font-bold text-blue-footer">$' +totInt+'</span> (an average of <span class="font-bold text-blue-footer">$'+monthlyInt+'</span> per month).</p>';
			  		  
			}
			myResultText = myResultText + '</div>';
			calcResults('#' + myBlock, myResultText, myPanel, myAccInner);
		} else {
			myAlertText = '<ul>';
			for (var j = 0; j < myAlerts.length; j++) {
				myAlertText = myAlertText + '<li>' + myAlerts[j] + '</li>';
			}
			myAlertText = myAlertText + '</ul>';			
			calcAlerts('#' + myBlock, myAlertText, myPanel, myAccInner);
		}				
	});	
	
	
	/* Mortgage calculator */
	
	function prePayTextTweak(myElement) {
		var myBlock = myElement.parents('.mortgagecalcform');
		var years = myBlock.find('.termfield').val();		
		var prepayMonthsRow = myBlock.find('.prepayment-months-row');
		var prepayMonthsField = prepayMonthsRow.find('.ppno-field');
		if (isNaN(parseInt(years))) {
			prepayMonthsField.attr('placeholder', 'Out of 360 total months for a 30 year long mortgage.');
		} else {			
			var months = years * 12;		
			prepayMonthsField.attr('placeholder', 'Out of '+months+' total months for a '+years+' year long mortgage.');
		}
	}
	
	$('.mortgagecalcform .termfield').on('keyup', function() {
		prePayTextTweak($(this)); 
	});
	
	$('.mortgagecalcform .prepselect').on('change', function(event) {
		var myBlock = $(this).parents('.mortgagecalcform');
		var value = $(this).find('option:selected').val();				
		var prepayMonthsRow = myBlock.find('.prepayment-months-row');
		var prepayAmountRow = myBlock.find('.prepayment-amount-row');
		var prepayAmountField = prepayMonthsRow.find('.ppno-field');
		var myAccInner = $(this).parents('.accordion-inner');			
		var myPanel = $(this).parents('.accordion-panel');
		
		if(value === 'None') {
			prepayMonthsRow.hide();
			prepayAmountRow.hide();
		} else if(value === 'One Time') {			
			prePayTextTweak($(this));		
			prepayMonthsRow.show();
			prepayAmountRow.show();
		} else {
			prepayAmountRow.show();
			prepayMonthsRow.hide();
		}
		if (myAccInner[0] != undefined && myPanel != undefined) {
			myPanel.height(myAccInner[0].scrollHeight);
		}
	});
		
	$('.mortgagecalcform').on('submit', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var myBlock, myData, myAlertText, myResultText, myFormVals, isValid, myAlerts, myPanel, myAccInner;
		myAccInner = $(this).parents('.accordion-inner');			
		myPanel = $(this).parents('.accordion-panel');
		/* Grab block id for submitted form */
		myBlock = $(this).data('blockid');
		isValid = true;
		/* put form submission data into object */
		myData = $(this).serializeArray();
		myAlerts = [];
		myAlertText = '';
		myFormVals = {};
		for (var i = 0; i < myData.length; i++) {
			myFormVals[myData[i].name] = myData[i].value;
		}
		/* Validate form submission */
		/* check value of loan balance if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.principal)) || parseFloat(myFormVals.principal) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a principal loan balance. Values must be more than 0.');
		}
		
		/* check value of term if set and numbers */		
		if ((isNaN(parseInt(myFormVals.term)) || parseInt(myFormVals.term) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter an amortization length. Values must be more than 0.');
		}
		
		/* check value of year if set and numbers */		
		if ((isNaN(parseInt(myFormVals.startyear)) || parseInt(myFormVals.startyear) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a start year.');
		}
		 
		/* check value of interest rate */
		if (isNaN(parseFloat(myFormVals.interestrate)) || parseFloat(myFormVals.interestrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an annual percentage rate greater than 0.00');
		}
		
		/* check value of prepayment amount */
		if ((isNaN(parseFloat(myFormVals.ppay)) || parseFloat(myFormVals.ppay) <= 0) && (myFormVals.prepselect !== 'None')) {
			isValid = false;
			myAlerts.push('Please enter a pre-payment amount. Value must be greater than 0.00');
		}
		
		/* check value of prepayment month field */
		if ((isNaN(parseInt(myFormVals.ppno)) || parseInt(myFormVals.ppno) <= 0) && (myFormVals.prepselect === 'One Time')) {
			isValid = false;
			var monthval = myFormVals.term * 12;
			myAlerts.push('Please enter a number of months for your one-time prepayment. Value must be between 1 and ' + monthval);
		}
		
		/* if form validates perform calculations, otherwise put up alerts */
		if (isValid) {			
			var startMonth = parseInt(myFormVals.startyear);
			var showFull = myFormVals.showfull;
			var years = parseInt(myFormVals.term);
			myResultText = '';
			var months = years * 12;
			var tt = years * 12;
			var arrayM = ["Foo",
			"Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",
			"B/W"];
			var outt = 'Table';
			var paymt;
			var tint2 = 0;
			var intcalc = parseFloat(myFormVals.interestrate)/1200;
			
			if (tt == 0) {
				tt = 360;
			}
			var temp = Math.pow((1 + intcalc), -tt);
			if (temp < 1) {
				paymt = (parseFloat(myFormVals.principal) * intcalc) / (1 - temp);
			} else {
				paymt = parseFloat(myFormVals.principal) / tt;
			}
			var tint = paymt * tt - parseFloat(myFormVals.principal);
			var bal = parseFloat(myFormVals.principal);
			var yrint = 0;
			var yrprin = 0;
			var mm = 0;
			var apay = 0;
			var ppay, bw_pay, bi_week, ot_pay;
			
			// # figure all pre-payment options
			if (myFormVals.prepselect == 'None') {
				apay = 0;
				ppay = 0;
			} 
			else if (myFormVals.prepselect == '1 full') {
				bw_pay = paymt;
				bi_week = 2;
				ppay = 0;
			}
			 else if (myFormVals.prepselect == '2 half') {
				bw_pay = paymt/2;
				bi_week = 1;
				ppay = 0;
			}
			else if (myFormVals.prepselect == 'Monthly') {
				apay = 0;
				ppay = parseFloat(myFormVals.ppay);
			}
			else if (myFormVals.prepselect == 'Annually') {
				apay = myFormVals.ppay;
				ppay = 0;
			}
			else if (myFormVals.prepselect == 'One Time') {
				ot_pay = parseFloat(myFormVals.ppay);
				ppay = 0;
			}
			else if(!ppay) {
				ppay = parseFloat(myFormVals.ppay);
			}
			
			var prettyprin = myFormVals.principal.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			if (outt == 'Table') {
			  myResultText = myResultText + "<div class='mt-base text-blue-footer text-2xl'>Your Mortgage Calculation</div>"+
			  "<div class='text-xl font-bold mt-base'>For the given values:</div>"+
			  "<table class='content-table firstColumnHeader mt-2x'><tbody>" +
			  "<tr><th class='text-left'>Principal</th><td class='text-left'>$"+prettyprin+"</td></tr>" +
			  "<tr><th class='text-left'>Interest Rate</th><td class='text-left'>"+myFormVals.interestrate+"%</td></tr>" +
			  "<tr><th class='text-left'>Amortization Period</th><td class='text-left'>"+myFormVals.term+" years</td></tr>" +
			  "<tr><th class='text-left'>Starting Month</th><td class='text-left'>"+arrayM[myFormVals.startmonth]+"</td></tr>" +
			  "<tr><th class='text-left'>Starting Year</th><td class='text-left'>"+myFormVals.startyear+"</td></tr>" +
			  ( bi_week  == 2 ? "<tr><th class='text-left'>BI-WEEKLY</th><td class='text-left'> 1 full payment/yr</td></tr>" : '') +
			  ( bi_week == 1 ? "<tr><th class='text-left'>BI-WEEKLY</th><td> 2 half payments/yr</td></tr>" : '') +
			  ( ppay > 0 ? "<tr><th class='text-left'>Monthly pre-Payment</th><td class='text-left'>"+ppay+"</td></tr>" : '') +
			  (apay > 0 ? "<tr><th class='text-left'>Annual Pre-Payment</th><td class='text-left'>$"+Number(apay).toFixed(2)+"</td></tr>" : '') +
			  (ot_pay > 0 ? "<tr><th class='text-left'>One Time Pre-Payment</th><td class='text-left'>$"+Number(ot_pay).toFixed(2)+" paid after month "+myFormVals.ppno : '');
			  myResultText = myResultText +'</tbody></table>';
			}
						
			myResultText = myResultText +'<div class="mt-base text-xl text-blue-footer">' +
					(bi_week > 0 ? "Your biweekly payment will be $"+Number(paymt/2).toFixed(2) :
					"Your monthly payment will be: $"+Number(paymt).toFixed(2)) + "</div>" + 
					(ppay > 0 ? "<div class='text-xl'>+ Monthly Prepayment of $"+Number(ppay).toFixed(2)+" = $" + Number((paymt + ppay)).toFixed(2) +"</div>" : '') + '</div>';
			
			
			if (outt == 'Table') {				
				
				myResultText = myResultText + '<div class="my-normal">The <b>Principal %</b> column shows the percentage of your regular payment that your principal payment is.</div>'
				
				// # Now do the amortization
				
				var first_yr = yrint;
				var lft = parseInt(myFormVals.term) - 1;
				var m = 1;
				var cm = myFormVals.startmonth;
				var mmax;
				
				myResultText = myResultText + '<table class="mt-base content-table firstRowHeader"><thead><tr><th class="text-left">Year</th><th class="text-center">Month</th><th class="text-center">Principal</th><th class="text-center">Principal %</th><th class="text-center">Interest</th><th class="text-center">Balance</th></tr></thead><tbody>';
								
				var cy = parseInt(myFormVals.startyear) + 0;				
				var bw = 0;
				if (myFormVals.showfull == 'Yes' ) {
					mmax = parseInt(myFormVals.term) * 12;
				} else {
					mmax = 12;
				}
				
				var tm = 0;
				
				while (m <= parseInt(myFormVals.term) * 12 && bal > 0) {
					var mint = intcalc * bal;
					console.log('mint:' + mint);
					bal = bal - paymt + mint - ppay;
					yrint = yrint + mint;					
					var mprin = paymt - mint + ppay;
					console.log('mprin:' + mprin);
					yrprin = yrprin + mprin;
					tm++;
					tint2 = tint2 + mint;					
					if (m <= mmax) {
						myResultText = myResultText + '<tr><td class="text-left"><span class="block md:hidden font-bold">Year</span>' + cy + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Month</span>' + arrayM[cm] + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal</span>$' + Number(mprin).toFixed(2) + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal %</span>' + Number(mprin*100/paymt).toFixed(2) + '%</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Interest</span>$' + Number(mint).toFixed(2) + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Balance</span>$' + Number(bal).toFixed(2) + '</td></tr>';
					}
					
					//# Perform one-time prepayment
					if (m == myFormVals.ppno && ot_pay > 0) {
						bal = bal - ot_pay;
						if (m <= mmax) {
							myResultText = myResultText + '<tr><td class="text-left" colspan="2"><span class="block font-bold">PREPAY--</span></td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal</span>$' + Number(ot_pay).toFixed(2) + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal %</span>' + Number(ot_pay*100/paymt).toFixed(2) + '%</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Interest</span>$0.00</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Balance</span>$' + Number(bal).toFixed(2) + '</td></tr>';						  
						}
					}
					
					// # Perform biweekly adjustment
				  	bw++;
				  	if (bw == bi_week * 6) {
						bal = bal - bw_pay;
						bw = 0;
						yrprin = yrprin + bw_pay;
						if (m <= mmax) {
					  	
					  		myResultText = myResultText + '<tr><td class="text-left" colspan="2"><span class="block font-bold">BIWEEKLY--</span></td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal</span>$' + Number(bw_pay).toFixed(2) + '</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Principal %</span>' + Number(bw_pay*100/paymt).toFixed(2) + '%</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Interest</span>$0.00</td><td class="text-left md:text-center"><span class="block md:hidden font-bold">Balance</span>$' + Number(bal).toFixed(2) + '</td></tr>';		  	
						}
				  	}
					  
				  	m++;
				  	cm++;
					  
				  	if (cm > 12) {
												
						myResultText = myResultText + '<tr class="bg-teal"><td class="text-left bg-teal text-white font-bold" colspan="2"><span class="block">Year Totals</span>' + cy + '</td><td class="text-left md:text-center bg-teal text-white font-bold"><span class="block">Principal</span>$' + Number(yrprin).toFixed(2) + '</td><td class="text-left md:text-center bg-teal text-white font-bold"><span class="block">Principal %</span>' + Number(yrprin*100/(12*paymt)).toFixed(2) + '%</td><td class="text-left md:text-center bg-teal text-white font-bold"><span class="block">Interest</span>$' + Number(yrint).toFixed(2) + '</td><td class="text-left md:text-center bg-teal text-white font-bold"><span class="block">Balance</span>$' + Number(bal).toFixed(2) + '</td></tr>'; 
						
						cy++;
						cm=1;
						yrprin = 0;
					}				
										
				} // END MAIN LOOP
				
				//# Print out Trailer
				if (parseInt(myFormVals.term) > 0) {
					var aint = tint2 / (parseInt(myFormVals.term) * 12);
				}
				
				myResultText = myResultText + '</tbody></table>';
				
				//# Print Results
				myResultText = myResultText + '<div class="mt-2x text-blue-footer text-2xl">Your Final Summary:</div>';
				
				if (bi_week > 0) {
					myResultText = myResultText + '<div class="mt-half text-xl"><b>Biweekly Payment:</b> $' + Number(paymt/2).toFixed(2) + "</div>";
				} else {
					myResultText = myResultText + '<div class="mt-half text-xl"><b>Monthly Payment:</b> $' + Number(paymt).toFixed(2) + "</div>";
				}
				
				myResultText = myResultText + '<div class="mt-half text-xl"><b>Total Interest (No pre-payment):</b> $' + Number(tint).toFixed(2) + '</div>';
				
				myResultText = myResultText + '<div class="mt-half text-xl"><b>Total Interest (As given):</b> $' + Number(tint2).toFixed(2) + '</div>';
				
				if (tint2 > 0)
				{
				  myResultText = myResultText + '<div class="mt-half text-xl"><b>SAVINGS:</b> $' + Number(tint - tint2).toFixed(2) + ' Total Interest Saved, ' + Number((tt - tm)/12).toFixed(2) + ' Years shorter loan</div>';
				}
				
				myResultText = myResultText + '<div class="mt-half text-xl"><b>Average Interest each Month:</b> $' + Number(aint).toFixed(2) + '</div>';
				
				if (tint2 < tint)
				{
				  var naint = tint / tt;
				  myResultText = myResultText + '<div class="mt-half text-xl"><b>SAVINGS: Normal Avg Int/Month:<b> $' + Number(naint).toFixed(2) + ', You Save $' + Number(naint - aint).toFixed(2) + '</div>';
				}
			} 	
								
			calcResults('#' + myBlock, myResultText, myPanel, myAccInner);
		} else {
			myAlertText = '<ul>';
			for (var j = 0; j < myAlerts.length; j++) {
				myAlertText = myAlertText + '<li>' + myAlerts[j] + '</li>';
			}
			myAlertText = myAlertText + '</ul>';			
			calcAlerts('#' + myBlock, myAlertText, myPanel, myAccInner);
		}				
	});
	
	/* buy/rent calculator */
		
	$('.buyrentcalcform').on('submit', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var myBlock, myData, myAlertText, myResultText, myFormVals, isValid, myAlerts, myPanel, myAccInner;
		myAccInner = $(this).parents('.accordion-inner');			
		myPanel = $(this).parents('.accordion-panel');
		/* Grab block id for submitted form */
		myBlock = $(this).data('blockid');
		isValid = true;
		/* put form submission data into object */
		myData = $(this).serializeArray();
		myAlerts = [];
		myAlertText = '';
		myFormVals = {};
		for (var i = 0; i < myData.length; i++) {
			myFormVals[myData[i].name] = myData[i].value;
		}
		/* Validate form submission */
		/* check value of monthly payment if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.monthlyspend)) || parseFloat(myFormVals.monthlyspend) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter a monthly spend amount. Values must be more than 0.00.');
		}
						 
		/* check value of down payment */
		if (isNaN(parseFloat(myFormVals.downpayment)) || parseFloat(myFormVals.downpayment) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an down payment amount greater than 0.00');
		}
		
		/* check value of interest rate */
		if (isNaN(parseFloat(myFormVals.interestrate)) || parseFloat(myFormVals.interestrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an annual interest rate greater than 0.00');
		}
				
		/* check value of term */
		if (isNaN(parseInt(myFormVals.loanlength)) || parseInt(myFormVals.loanlength) <= 0) {
			isValid = false;
			myAlerts.push('Please enter a loan length greater than 0');
		}
		
		/* check value of inflation rate */
		if (isNaN(parseFloat(myFormVals.inflation)) || parseFloat(myFormVals.inflation) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an expected log-term inflation greater than 0.00');
		}
		
		/* check value of investment return rate */
		if (isNaN(parseFloat(myFormVals.investmentreturn)) || parseFloat(myFormVals.investmentreturn) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an expected log-term investment return greater than 0.00');
		}
		
		/* check value of long term tax rate */
		if (isNaN(parseFloat(myFormVals.taxrate)) || parseFloat(myFormVals.taxrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an expected log-term tax rate greater than 0.00');
		}		
		
		/* if form validates perform calculations, otherwise put up alerts */
		if (isValid) {
			var intRateNum = Number(myFormVals.interestrate);
			var monthSpendNum = Number(myFormVals.monthlyspend);
			var downPayNum = Number(myFormVals.downpayment);
			var inflationNum = Number(myFormVals.inflation);
			var jay = Number(myFormVals.interestrate)/1200;
			var year = parseInt(myFormVals.loanlength);
			var amv = (1 - Math.pow((1 + jay), (-year * 12)))/jay;			
			var loan = Number(amv * myFormVals.monthlyspend).toFixed(2);			
			var bal = amv * monthSpendNum;
			var houseVal = +loan + +downPayNum;			
			var house = Number(houseVal).toFixed(2);
			
			// below compartmentalizing the houseFV numbers for readability
			var one = 1 + (inflationNum/100);
			var two = parseInt(myFormVals.loanlength);
			var combo = Math.pow(one, two) * house;
			var houseFV = Number(combo).toFixed(2);
			var totInt = 0;
						
			for(var x = 0; x < year * 12; x++) {
				var cint = bal * +intRateNum/1200;
				console.log(cint);
				totInt += cint;
				bal += cint - +monthSpendNum;
			}
					
			
			var taxSave = Number(parseFloat(myFormVals.taxrate)/100 * totInt).toFixed(2);
			var totI = Number(totInt).toFixed(2);
			var dp_fv = Number(myFormVals.downpayment * Math.pow((1 + +parseFloat(myFormVals.investmentreturn)/100),myFormVals.loanlength)).toFixed(2);
			
			myResultText = '<div class="text-2xl text-blue-footer mt-normal">Mortgage Analysis</div><div class="<div class="mt-base text-xl">With your monthly payment of <strong>$' + myFormVals.monthlyspend + '</strong> and a <strong>' + myFormVals.loanlength + '</strong> Year Loan at <strong>' + myFormVals.interestrate + '%</strong> :<br>' + 'You will have a loan of <strong>$' + loan + '</strong>.<br>' +
			'Adding your down payment of <strong>$' + myFormVals.downpayment + '</strong> gives a total house value of <strong>$' + house + '</strong>.<br>' +	'After <strong>' + myFormVals.loanlength + '</strong> years you will own a <strong>$' + houseFV + '</strong> house and have saved <strong>$' + taxSave + '</strong> in income taxes on interest payments of <strong>$' + totI + '</strong>' +	'</div><div class="mt-2x text-2xl text-blue-footer">Renting Analysis</div>' + 'Instead we take your down payment and let it grow. After <strong>' + myFormVals.loanlength + '</strong> years your <strong>$' + myFormVals.downpayment + '</strong> has increased to <strong>$' + dp_fv + '.</strong></div>';
			calcResults('#' + myBlock, myResultText, myPanel, myAccInner);
			
		} else {
			myAlertText = '<ul>';
			for (var j = 0; j < myAlerts.length; j++) {
				myAlertText = myAlertText + '<li>' + myAlerts[j] + '</li>';
			}
			myAlertText = myAlertText + '</ul>';			
			calcAlerts('#' + myBlock, myAlertText, myPanel, myAccInner);
		}				
	});
	
	
	/* simple savings calculator */
		
	$('.savingscalcform').on('submit', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var myBlock, myData, myAlertText, myResultText, myFormVals, isValid, myAlerts, myPanel, myAccInner;
		myAccInner = $(this).parents('.accordion-inner');			
		myPanel = $(this).parents('.accordion-panel');
		/* Grab block id for submitted form */
		myBlock = $(this).data('blockid');
		isValid = true;
		/* put form submission data into object */
		myData = $(this).serializeArray();
		myAlerts = [];
		myAlertText = '';
		myFormVals = {};
		for (var i = 0; i < myData.length; i++) {
			myFormVals[myData[i].name] = myData[i].value;
		}
		/* Validate form submission */
		/* check value of monthly payment if set and numbers */		
		if ((isNaN(parseFloat(myFormVals.initialamount)) || parseFloat(myFormVals.initialamount) <= 0)) {
			isValid = false;
			myAlerts.push('Please enter an initial amount. Values must be more than 0.00.');
		}
						 
		/* check value of down payment */
		if (isNaN(parseFloat(myFormVals.monthlydeposit)) || parseFloat(myFormVals.monthlydeposit) < 0) {
			if (myFormVals.monthlydeposit != '') {
				isValid = false;
				myAlerts.push('Please enter a monthly deposit amount greater than or equal to 0.00');
			} else {
				myFormVals.monthlydeposit = 0;	
			}			
		}
		
		/* check value of interest rate */
		if (isNaN(parseFloat(myFormVals.interestrate)) || parseFloat(myFormVals.interestrate) <= 0) {
			isValid = false;
			myAlerts.push('Please enter an annual interest rate greater than 0.00');
		}
				
		/* check value of term */
		if (isNaN(parseInt(myFormVals.years)) || parseInt(myFormVals.years) <= 0) {
			isValid = false;
			myAlerts.push('Please enter a number of years greater than 0');
		}
		
		if (myFormVals.years % 1 !== 0) {
			isValid = false;
			myAlerts.push('Number of years must be a whole number.');
		}
		
		
		/* if form validates perform calculations, otherwise put up alerts */
		if (isValid) {
			
			var yrs = parseInt(myFormVals.years);
			var int = parseFloat(myFormVals.interestrate);
			var amt = parseFloat(myFormVals.initialamount);
			var dep = parseFloat(myFormVals.monthlydeposit);
			var cmp = $(this).find(".compoundedselect").val();
			// var cmp = $('#compounded-select').val();
			var py = 12;
			
			if (cmp === 'Q') { py = 4; }
			if (cmp === 'S') { py = 2; }
			if (cmp === 'A') { py = 1; }
			
			var tt = yrs * py;
			var englishCompound = $(this).find('.compoundedselect option:selected').text()[0].toLowerCase() + $(this).find('.compoundedselect option:selected').text().slice(1);
			
						
			myResultText = '<div class="text-2xl text-blue-footer mt-normal">Simple Savings Estimations</div><div class="mt-base text-xl">Your monthly deposit of <strong>$'+ Number(dep).toFixed(2) + '</strong> for <strong>' + yrs + '</strong> Years at an interest rate of <strong>' + int + '</strong>% compounded <strong>' + englishCompound + '</strong> with an initial amount of $' + amt + ' will earn:</div>';
			
			var mi = int / (py * 100);
			var sav = amt;
			
			myResultText = myResultText + '<table class="mt-base content-table firstRowHeader"><thead><tr><th class="text-left">Year</th><th class="text-right">Balance</th></tr></thead><tbody>';
			
			for (var l = 1; l <= yrs; l++) {
				
				for (var k=0; k<12; k++){
				
					if (py == 12) {
					   sav = sav * (1 + mi);
					}
					if (py == 4 && (k == 2 | k == 5 | k == 8 | k == 11)) {
					   sav = sav * (1 + mi);
					}
					if (py == 2 && (k == 5 | k == 11)) {
					   sav = sav * (1 + mi);
					}
					if (py == 1 && k == 11) {
					   sav = sav * (1 + mi);
					}
					sav = sav + dep;
				}
				
				myResultText = myResultText + '<tr><td class="text-left"><span class="block md:hidden font-bold">Year</span>'+ l +'</td><td class="text-left md:text-right"><span class="block md:hidden font-bold">Balance</span>$' + Number(sav).toFixed(2) + '</td></tr>';
				 
			}
			
			myResultText = myResultText + '</tbody></table>';
			myResultText = myResultText + '<div class="mt-2x text-blue-footer text-xl">Final savings balance: $' + Number(sav).toFixed(2) + '</div>';
			
			calcResults('#' + myBlock, myResultText, myPanel, myAccInner);
			
			
		} else {
			myAlertText = '<ul>';
			for (var j = 0; j < myAlerts.length; j++) {
				myAlertText = myAlertText + '<li>' + myAlerts[j] + '</li>';
			}
			myAlertText = myAlertText + '</ul>';			
			calcAlerts('#' + myBlock, myAlertText, myPanel, myAccInner);
		}				
	});
	
	
	/* INFO REQUEST AND BUSINESS INQUIRY FORM HELPERS */
	if ($('body').data('inquiry-type') == '0') {		
		$('#form-input-businessInquiryRecipient').val('Opening a Business Deposit Account').change();
		$('#form-input-whatKindOfAccount').val($('body').data('requestproduct')).change();
	}
	
	if ($('body').data('inquiry-type') == '1') {		
		$('#form-input-businessInquiryRecipient').val('Applying for a Business Loan or Credit Card').change();
		$('#form-input-whatKindOfLoan').val($('body').data('requestproduct')).change();
	}
	
	/*
	$('#form-input-businessInquiryRecipient').on('change', function() {
		if ($(this).val() == 0) {
			$('#form-input-interestedIn').val('Opening a Business Deposit Account');
		} else if ($(this).val() == 1) {
			$('#form-input-interestedIn').val('Applying for a Business Loan or Credit Card');
		}
	});
	*/
	
	$('#form-input-requestProduct').val($('body').data('requestproduct'));
	
			
	/* EVENT FORM */
	
	$('#form-input-event').val($('body').data('eventtag'));
	
	/* CARD CUSTOMIZER */
	
	var customizerUrls = {
		'Personal Debit': 'https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?LanguageId=en-US&Handover_Key=95cdbf0a-e3a7-4f2b-8f76-ae32bc621aeb',
		'Campus Prestige': 'https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?LanguageId=en-US&Handover_Key=5c89cb7d-0fa2-42d8-951c-6a5acf541852',
		'Campus Rewards': 'https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?LanguageId=en-US&Handover_Key=f548353b-ddb8-4dcc-bbed-5b2199b83040',
		'Business Debit': 'https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?LanguageId=en-US&Handover_Key=dd14dce9-da0f-4533-8ca0-f8bfe20dc2ac',
		'Business Credit': 'https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?LanguageId=en-US&Handover_Key=68af22e9-1292-4175-afe5-e5361e74f392'
	};
	
	$('.mcc-customizer-btn').on('click', function() {
		var myKey = $(this).data('urlkey');
		$('#mcc-customizer-panelheader').html('Customize Your ' + myKey + ' Card');
		$('#card-customizer').attr('src', customizerUrls[myKey]);
		$('#mcc-customizer-panel-1').hide();
		$('#mcc-customizer-panel-2').show();
	});
	
	$('#mcc-customizer-back').on('click', function() {			
		$('#mcc-customizer-panel-2').hide();
		$('#mcc-customizer-panel-1').show();		
	});
	
	$(document).on('click', '#header-md-searchbtn', function() {
		$('#searchmodule_md').addClass('searchactive');
		$('#secondary_menu_md').addClass('searchactive');
	});
	
	$(document).on('click', '#btn-searchmodule-md-close', function() {
		$('#searchmodule_md').removeClass('searchactive');
		$('#secondary_menu_md').removeClass('searchactive');
	});
	
	$(document).on('click', '#mobile-search-btn', function() {
		$('#main-nav-wrapper').addClass('searchactive');
		$('#mobile-search-wrapper').addClass('searchactive');
		$('q-mobile').click();
	});
	
	$(document).on('click', '#btn-mobilesearch-close', function() {
		$('#main-nav-wrapper').removeClass('searchactive');
		$('#mobile-search-wrapper').removeClass('searchactive');
	});
	
	
	$(document).on('click', '.searchinput', function(e) {
		var elem = e.target;
		var parentform = $(elem).closest('.searchform');
		var suggestionelem = parentform.find('.suggestions');		
		suggestionelem.show();
		parentform.addClass('dropactive');
	});
	
	$(document).on('click', function(e) {
		var elem = e.target;		
		if ($(elem).parents('.searchform').length == 0) {			
			$('.suggestions').hide();
			$('.searchform').removeClass('dropactive');
		}		
	});
	
		
});


